import { render, staticRenderFns } from "./RegistroResposta.vue?vue&type=template&id=5dc78c5c&"
import script from "./RegistroResposta.vue?vue&type=script&lang=js&"
export * from "./RegistroResposta.vue?vue&type=script&lang=js&"
import style0 from "./RegistroResposta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports